import {
  PERSONAL_HUB_SECTION_BLUEPRINTS,
  PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS,
  PERSONAL_HUB_SECTION_HANGAR,
} from '../personalHubRailConfig';

export const loadHangarSection = () => import('../Hangar');
export const loadFactionReputationSection = () => import('../FactionReputation');
export const loadBlueprintSection = () => import('../Blueprint');

const SECTION_LOADERS = {
  [PERSONAL_HUB_SECTION_HANGAR]: loadHangarSection,
  [PERSONAL_HUB_SECTION_FACTIONS_REPUTATIONS]: loadFactionReputationSection,
  [PERSONAL_HUB_SECTION_BLUEPRINTS]: loadBlueprintSection,
};

const started = new Set();

export function preloadPersonalHubSection(section) {
  const load = SECTION_LOADERS[section];
  if (!load) return Promise.resolve();
  if (started.has(section)) return load();
  started.add(section);
  return load();
}

export function preloadPersonalHubSections(sections) {
  return Promise.all(sections.map((section) => preloadPersonalHubSection(section)));
}
